import { useState } from "react"
import { computed } from "mobx"
import { observer } from "mobx-react-lite"
import { Button, Col, Flex, Row } from "antd"
import { FileExcelOutlined } from "@ant-design/icons"

import { ModalReports } from "@src/app/components/ModalReports"
import { DefaultPageLayout } from "@src/app/layouts/DefaultPageLayout"
import TransactionsCollection from "@src/app/transactionsStore/TransactionsCollection"
import { noContent } from "@src/pages/reports/constants"
import { ReportsTable } from "@src/pages/reports/ui/ReportsTable"
import { TableFilters } from "@src/shared/componemts/TableFilter"

export const ReportsPage = observer(() => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const transactionsCollection = TransactionsCollection()

  const [isLoading, isEmpty] = computed(() => {
    if (transactionsCollection.filter.isActive) {
      return [false, false]
    }

    return [
      transactionsCollection.isLoading && transactionsCollection.isEmpty,
      transactionsCollection.isEmpty,
    ]
  }).get()

  return (
    <DefaultPageLayout
      button={
        <Button
          icon={<FileExcelOutlined />}
          id="GENERATED_ID_REPORTS_BUTTON_DOWNLOAD_1"
          onClick={() => setIsModalOpen(true)}
          size="large"
          type="primary"
        >
          Generate report
        </Button>
      }
      emptyBlock={noContent}
      isEmpty={isEmpty}
      isLoading={isLoading}
      title="Reports"
    >
      <>
        <Flex gap={16} vertical>
          <TableFilters {...transactionsCollection.filter.props} />
          <ReportsTable collection={transactionsCollection} />
        </Flex>

        <ModalReports
          isOpen={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
        />
      </>
    </DefaultPageLayout>
  )
})
